/**
 * KD3 S2109 (BUG-S2109-001): dropdown ที่ดึงเฉพาะรายการ "ใช้งาน" แต่ค่าของแถวที่กำลังแก้ชี้ไปที่รายการ
 * ที่ถูกปิดแล้ว → <select> ไม่มี option ที่ตรงกับค่า เบราว์เซอร์จึงโชว์ "-- เลือก... --"
 * ผู้ใช้เห็นว่าแถวนี้ "ไม่มียี่ห้อ" ทั้งที่ DB ยังผูกอยู่ · เติมรายการปัจจุบันกลับเข้าไปพร้อมป้าย (ปิดใช้งาน)
 */
export interface NamedOption { id: number; name: string }

export function withCurrentOption<T extends NamedOption>(
  options: T[],
  current: NamedOption | null | undefined,
  suffix = ' (ปิดใช้งาน)',
): NamedOption[] {
  if (!current || current.id == null) return options;
  if (options.some(o => String(o.id) === String(current.id))) return options;
  return [...options, { id: current.id, name: `${current.name}${suffix}` }];
}
